<template>
    <div>
      <div class="row">
        <div class="col-5 mb-4">
          <h1>{{ $t("learning-outcome-groups") }}</h1>
        </div>
        <div class="col-7 mb-4" v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">
          <button @click="showAddGroupModal = true" class="float-right btn btn-primary">
            <b-icon icon="plus"></b-icon> {{ $t("new") }}
          </button>
          <NewItem
            v-if="showAddGroupModal"
            endpointRoute="learningoutcome/group/save"
            :fields="newGroupFields"
            @saved="handleNewGroupSaved"
            @close="showAddGroupModal = false"
          />
        </div>
      </div>
  
      <Table
        :loading="!loaded"
        :submitting="submitting"
        :cols="[
          { key: 'title', heading: $t('title'), size: 8, sortable: true, sortCol: 'LastName' },
          { key: 'source_text', heading: $t('source'), size: 4 }
        ]"
        :data="outcomeGroups"
        breakpoint="md"
        :filters="{
          ...filters,
          page: filters.page,
          page_size: filters.page_size
        }"
        :searchable="true"
        :scrollPaginate="true"
        @refresh="refresh"
        @toPage="toPage"
        @selectItem="group => $router.push(`/curriculum-mapping/learning-outcomes/group/${group.id}`)"
        :allowRightClick="true"
        @deleteItem="openDeleteDialog"
      >
        <template v-slot:header>
          <div class="list-group-item">
            <div class="row">
              <div class="col-md-6">
                <MultiselectSearchInput
                  :label="$t('curricula')"
                  v-model="filters.curriculum_ids"
                  :options="curricula"
                  optionLabel="title"
                  optionValue="id"
                  @input="value => refresh({ curriculum_ids: value })"
                />
              </div>
              <div class="col-md-6">
                <MultiselectSearchInput
                  :label="$t('learning-outcome-groups')"
                  v-model="filters.group_ids"
                  :options="allGroups"
                  optionLabel="title"
                  optionValue="id"
                  @input="value => refresh({ group_ids: value })"
                />
              </div>
            </div>
          </div>
        </template>
      </Table>
    </div>
  </template>
  
  <script>
  import Table from "src/components/Table/Table.vue";
  import NewItem from "src/components/modals/NewItem.vue";
  
  export default {
    components: {
      Table,
      NewItem,
    },
    data() {
      return {
        outcomeGroups: null,
        curricula: [],
        allGroups: [],
        loaded: false,
        submitting: false,
        filters: {
          page: 1,
          page_size: 30,
          search: '',
          programme: '',
          year: '',
          curriculum_ids: [],
          group_ids: []
        },
        showAddGroupModal: false,
        newGroupFields: [
          { id: 'id',    label: null,    value: '' },
          { id: 'title', label: 'title', value: '', mandatory: true },
          { id: 'note',  label: 'notes', value: '' }
        ]
      };
    },
    mounted() {
      this.getOutcomesGroups();
      this.fetchCurricula();
      this.fetchAllGroups();
    },
    methods: {
      getOutcomesGroups() {
        if (this.submitting) return;
        this.submitting = true;
        this.$cfetch(
          `${this.$settings.APIBaseURL}/learningoutcome/group/list`,
          { method: 'post', data: this.filters }
        )
        .then(res => {
          if (res.status === 'SUCCESS') {
            this.outcomeGroups = res.results;
            this.outcomeGroups.forEach(group => {
              if (group.class === '0') group.source_text = this.$t('internal-learning-outcomes');
              else if (group.class === '1') group.source_text = this.$t('external-learning-outcomes');
            });
            this.loaded = true;
          } else {
            console.error('Could not fetch groups');
          }
        })
        .finally(() => {
          this.submitting = false;
        });
      },
  
      refresh(filters) {
        this.filters = { ...this.filters, ...filters, page: 1 };
        this.getOutcomesGroups();
      },
      toPage(pageNo) {
        this.filters.page = pageNo;
        this.getOutcomesGroups();
      },
  
      openDeleteDialog(item) {
        this.selectedItem = item;
        this.$store.commit('openDialog', {
          title: this.$t('are-you-sure'),
          content: this.$t('delete-{e}-warning', { e: this.$t('learning-outcome-group') }),
          cancelBtn: true,
          confirmCallBack: this.removeItem,
        });
      },
      removeItem() {
        if (!this.selectedItem) return;
        this.$store.commit('showBlockingSpinner');
        this.$cfetch(
          `${this.$settings.APIBaseURL}/learningoutcome/group/delete`,
          { method: 'POST', data: { id: this.selectedItem.id } }
        )
        .then(res => {
          this.$store.commit('hideBlockingSpinner');
          if (res.status !== 'SUCCESS') throw new Error('Unexpected error deleting LOG');
          this.outcomeGroups = this.outcomeGroups.filter(g => g.id !== this.selectedItem.id);
        })
        .catch(err => {
          this.$store.commit('hideBlockingSpinner');
          this.$log.error.call(this, err);
          this.$store.commit('openDialog', {
            title: this.$t('something-went-wrong'),
            content: this.$t('error-delete-{e}', { e: this.$t('learning-outcome-group') }),
          });
        })
        .finally(() => {
          this.selectedItem = undefined;
        });
      },
  
      fetchCurricula() {
        this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/listroots`, { method: 'post', data: {} })
          .then(res => {
            if (res.status === 'SUCCESS') this.curricula = res.results;
          });
      },
      fetchAllGroups() {
        this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/group/list`, { method: 'post', data: {} })
          .then(res => {
            if (res.status === 'SUCCESS') this.allGroups = res.results;
          });
      },
      handleNewGroupSaved() {
        this.showAddGroupModal = false;
        this.getOutcomesGroups();
      }
    }
  };
  </script>
  